<ng-container [ngSwitch]="result?.allRecordsMatch">
  <ng-container *ngSwitchCase="true">
    <mat-icon class="green">check_circle_filled</mat-icon>
  </ng-container>
  <ng-container *ngSwitchCase="false">
    <mat-icon class="red">error</mat-icon>
  </ng-container>
</ng-container>
